import { ResponsiveBlockSwitcher } from "@/shared/Components";
import type { PhoneNumberProps } from "../model";
import { Desktop, Mobile } from "./components";

export const PhoneNumberForm = (props: PhoneNumberProps) => {
  return (
    <ResponsiveBlockSwitcher desktop={<Desktop {...props} />} mobile={<Mobile {...props} />} />
  );
};
